import React, { useRef, useEffect } from 'react';
  import Hls from 'hls.js';

  const VideoPlayer = ({ streamUrl, channelId, width = 640, height = 360 }) =>
  {
      const videoRef = useRef(null);
      const hlsRef = useRef(null);

      useEffect(() => {
          if (!streamUrl || !videoRef.current) return;

          const video = videoRef.current;

          if (Hls.isSupported()) {
              // Chrome, Firefox, Edge - use Hls.js
              const hls = new Hls({
                  enableWorker: false, // Disable for compatibility
                  xhrSetup: (xhr) => {
                      xhr.timeout = 10000; // 10 second timeout
                  }
              });

              hls.loadSource(streamUrl);
              hls.attachMedia(video);

              hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  console.log(`HLS stream ready for ${channelId}`);
              });

              hls.on(Hls.Events.ERROR, (event, data) => {
                  console.error('HLS Error:', data);
                  if (data.fatal) {
                      switch(data.type) {
                          case Hls.ErrorTypes.NETWORK_ERROR:
                              console.log('Network error - trying to recover');
                              hls.startLoad();
                              break;
                          case Hls.ErrorTypes.MEDIA_ERROR:
                              console.log('Media error - trying to recover');
                              hls.recoverMediaError();
                              break;
                          default:
                              hls.destroy();
                              break;
                      }
                  }
              });

              hlsRef.current = hls;
          } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              // Safari - native support
              video.src = streamUrl;
              video.addEventListener('loadedmetadata', () => {
                  console.log(`Native HLS stream ready for ${channelId}`);
              });
          } else {
              console.error('HLS not supported in this browser');
          }

          // Cleanup
          return () => {
              if (hlsRef.current) {
                  hlsRef.current.destroy();
              }
          };
      }, [streamUrl, channelId]);

      if (!streamUrl) {
          return (
              <div style={{ 
                  width, 
                  height, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #ccc',
                  borderRadius: '4px'
              }}>
                  <p>No stream available</p>
              </div>
          );
      }

      return (
          <video 
              ref={videoRef}
              controls
              width={width}
              height={height}
              style={{ 
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  backgroundColor: '#000'
              }}
              playsInline // Important for mobile
              muted // Some browsers require muted for autoplay
          />
      );
  };

  export default VideoPlayer;
